/* eslint-disable complexity */
import { CARD_STATE, INSTALLMENT_LOAN_STATE, INSURANCE_STATE, REFERRAL_STATUS, STATUS } from '../types/enums';

export const STATUS_MAPPER_CLASS = (status: string): string => {
  switch (status) {
    case STATUS.APPROVED:
    case STATUS.ENABLE:
    case STATUS.ENABLED:
    case STATUS.FINISHED:
    case STATUS.COMPLETED:
    case STATUS.ACTIVE:
    case STATUS.ACTIVATED:
    case STATUS.SUCCESS:
      return 'success_status';
    case STATUS.RETRY:
    case STATUS.PENDING:
    case STATUS.PENDING_VALIDATION:
    case STATUS.CREATED:
    case STATUS.SCHEDULED:
      return 'pending_status';
    case STATUS.STARTED:
    case STATUS.IN_PROGRESS:
      return 'in_progress_status';
    case STATUS.DECLINED:
    case STATUS.BLOCKED:
    case STATUS.REJECTED:
    case STATUS.CANCELED:
    case STATUS.CANCEL:
    case STATUS.CLOSED:
    case STATUS.DENIED:
    case STATUS.FAILED:
    case STATUS.DISABLE:
    case STATUS.DISABLED:
    case STATUS.PAYMENT_FAILED:
      return 'error_status';
    case STATUS.FROZEN:
      return 'text-blue';
    case STATUS.INACTIVE:
      return 'text-gray';
    default:
      return '';
  }
};

export const CARD_STATUS_MAPPER = (status: string): string => {
  switch (status) {
    case CARD_STATE.ACTIVE:
      return 'success_status';
    case CARD_STATE.BLOCKED:
    case CARD_STATE.REPLACED:
      return 'pending_status';
    case CARD_STATE.FROZEN:
      return 'in_progress_status';
    case CARD_STATE.INACTIVE:
      return 'text-purple';
    case CARD_STATE.CANCEL:
      return 'error_status';
    default:
      return '';
  }
};

export const REFERRAL_STATUS_MAPPER = (status: REFERRAL_STATUS): string => {
  switch (status) {
    case REFERRAL_STATUS.SUCCESS:
      return 'success';
    case REFERRAL_STATUS.INVALID:
      return 'warn';
    case REFERRAL_STATUS.PENDING:
      return 'warning';
    default:
      return 'primary';
  }
};

export const BOOLEAN_MAPPER_CLASS = (value: boolean): string => {
  return value && value === true ? 'success_status' : 'error_status';
};

export const INSTALLMENT_LOAN_STATUS_MAPPER = (status: string): string => {
  switch (status) {
    case INSTALLMENT_LOAN_STATE.ACTIVE:
      return 'active_status';
    case INSTALLMENT_LOAN_STATE.PENDING:
      return 'pending_status';
    case INSTALLMENT_LOAN_STATE.CANCELED:
      return 'canceled_status';
    case INSTALLMENT_LOAN_STATE.PAST_DUE_LOW:
      return 'past_due_low_status';
    case INSTALLMENT_LOAN_STATE.PAST_DUE_HIGH:
      return 'past_due_high_status';
    default:
      return 'other_status';
  }
};

export const INSURANCE_STATUS_MAPPER = (status: string): string => {
  switch (status) {
    case INSURANCE_STATE.ACTIVE:
      return 'active_status';
    case INSURANCE_STATE.PENDING:
      return 'pending_status';
    case INSURANCE_STATE.CANCELED:
      return 'canceled_status';
    case INSURANCE_STATE.ARREARS:
      return 'arrears_status';
    case INSURANCE_STATE.TO_CANCEL:
      return 'to_cancel_status';
    case INSURANCE_STATE.CLAIM:
      return 'claim_status';
    default:
      return 'other_status';
  }
};
